<template>
  <div class="header-container">
    <div class="status-bar">
      <!-- 左侧 Logo -->
      <div class="logo-wrapper">
        <div class="info-wrapper" @click="openSchoolPicker">
          <!-- 图标 -->
          <van-icon name="award" class="info-icon" />
          <span class="info-label">当前学校：</span>
          
          <!-- 学校名称 (点击触发) -->
          <span class="info-value">{{ currentSchoolName }} {{ teacherName }}</span>
          <!-- 下拉指示箭头 -->
          <van-icon name="arrow-down" class="arrow-icon" />
        </div>
      </div>

      <div class="left-slot">
        <slot name="left"></slot>
      </div>
      <div class="center-slot">
        <slot name="center"></slot>
      </div>
    </div>

    <!-- 底部弹出的学校选择器 -->
    <van-popup v-model="showSchoolPicker" round position="bottom">
      <van-picker
        show-toolbar
        title="切换学校"
        :default-index="defaultPickerIndex"
        :columns="schoolByTeacherList"
        value-key="schoolName"
        @cancel="showSchoolPicker = false"
        @confirm="onConfirmSchool"
      />
    </van-popup>
  </div>
</template>

<script>
import req from '@/utils/request2.js';
import { getOneSchoolByTeacherOpenId } from "@/api/teacher";
import { setSession, setSessionJSON, getLocal,setLocal } from "@/utils/cookie";
import { loginByOpenId} from "@/api/bind";

export default {
  name: 'ProjectHeader',
  props: {
  
  },
  data() {
    return {
      statusData: {},
      displayStatusName: '加载中...',
      defaultPickerIndex:0,
      projects: [
      ],
      schoolByTeacherList: [], // 学校列表数据源
      showSchoolPicker: false, // 控制弹窗显示
      currentSchoolName: '',   // 当前选中的学校名称
      currentSchoolCode: '',    // 当前选中的学校编码
      teacherName:"",
      teacherCode:"",
    }
  },

  computed: {

  },
  created() {
    this.init()
  },
  methods: {
    // 初始化获取学校列表
    init() {
      const openId = getLocal('openId')
      getOneSchoolByTeacherOpenId({
        openId: openId
      }).then(res => {
        if (res.data && res.data.data && res.data.data.length > 0) {
          this.schoolByTeacherList = res.data.data;
          
        }
      })
    },
   // 更新当前学校（统一处理响应式数据和存储）
    updateCurrentSchool(school) {
      this.currentSchoolName = school.schoolName;
      this.currentSchoolCode = school.schoolCode;

      this.teacherName = school.teacherName;
      this.teacherCode = school.teacherId;
      
      sessionStorage.setItem('teacherTitleInfo', JSON.stringify(school));
      // 更新全局存储（根据业务需要）
      // setSession('schoolCode', school.schoolCode);
    },
    // 打开选择器
    openSchoolPicker() {
      // 只有当有学校列表时才打开
      if (this.schoolByTeacherList.length > 0) {
           // 查找当前学校在列表中的索引
        const currentIndex = this.schoolByTeacherList.findIndex(
          school => school.schoolCode === this.currentSchoolCode
        );
        
        // 如果找到有效索引则使用，否则回退到0
        this.defaultPickerIndex = currentIndex >= 0 ? currentIndex : 0;
        this.showSchoolPicker = true;
      } else {
        this.$toast ? this.$toast('暂无学校信息') : alert('暂无学校信息');
      }
    },

    // 确认选择学校
   async onConfirmSchool(value) {
      console.log('选择的学校:', value);
      
      // 1. 更新视图显示
      this.currentSchoolName = value.schoolName;
      this.currentSchoolCode = value.schoolCode;

      this.teacherName = value.teacherName;
      this.teacherCode = value.teacherId;
      sessionStorage.setItem('teacherTitleInfo', JSON.stringify(value));
     await this.changeUSER()
      // // 2. 存储到 Session 或 Cookie (根据你的业务需求)
      // setSession('schoolCode', value.schoolCode);
      // setSession('schoolName', value.schoolName);
      // 如果需要存整个对象
      // setSessionJSON('currentSchool', value);

      // 3. 关闭弹窗
      this.showSchoolPicker = false;

      // 4. 触发回调：通知父组件或刷新当前状态
      // 这里的 refreshStatus 是你原来逻辑里的，如果切换学校需要刷新状态，可以调用
      // this.refreshStatus(); 
      
      // 5. 抛出事件给父组件 (可选)
      // this.$emit('school-changed', value);
      
      // 6. 如果需要刷新整个页面 (可选)
      // window.location.reload();
    },
   async changeUSER(){
       await loginByOpenId({
          openId:getLocal('openId'),
          schoolCode:this.currentSchoolCode
        }).then(res=>{
              console.log(res);
              if (res.data.obj=="personBindErrorCode") {
              }else{
              setLocal("userInfo", JSON.stringify(res.data.body));
              setLocal("Authorization", res.data.body.token);
              }
              }).catch((error) => {
              console.log(response);
            })
    },

    async refreshStatus() {
      // ... 保持你原有的 refreshStatus 代码不变 ...
      // 略 ...
    }
  },
  mounted() {
    // this.refreshStatus();
  }
}
</script>

<style scoped>
.header-container {
  /* 外层容器，负责整体留白 */
  /* padding: 10px 15px; */
  /* 如果你的页面背景不是渐变，可以在这里加，或者保持透明 */
}

.status-bar {
  position: relative;
  height: 30px; /* 根据截图目测的高度 */
  /* background-color: #fff; */
  /* border: 1px solid #2c3e50; 深色边框 */
  border-radius: 12px; /* 圆角做成胶囊状 */
  display: flex;
  align-items: center;
  justify-content: flex-end; /* 内容靠右对齐 */
  padding-right: 20px;
  /* box-shadow: 0 2px 6px rgba(0,0,0,0.05); */

   background: rgba(255, 255, 255, 0.65); /* 提高白底透明度，更干净 */
  backdrop-filter: blur(16px) ;
  -webkit-backdrop-filter: blur(16px) ;
  
  /* 边框高光 */
  border: 1px solid rgba(255, 255, 255, 0.8);
  /* 柔和阴影 */
  box-shadow: 0 4px 24px -1px rgba(0, 0, 0, 0.05);
}
.left-slot{
    flex: 1; /* 让这个插槽占据中间所有的剩余空间 */
  display: flex;
  align-items: center;
  justify-content: center; /* 让插槽内的内容居中，也可以改为 flex-start 靠左 */
}
.center-slot {
  flex: 1; /* 让这个插槽占据中间所有的剩余空间 */
  display: flex;
  align-items: center;
  justify-content: center; /* 让插槽内的内容居中，也可以改为 flex-start 靠左 */
}


/* Logo 容器 */
.logo-wrapper {
  position: absolute;
  left: 10px; /* 向左突出 */
  top: -10px; /* 向上突出 */
  bottom: -5px; /* 向下突出 */
  z-index: 10;
  display: flex;
  align-items: center;
}

.logo-img {
  height: 50px; /* Logo 高度要比 status-bar 高，才能产生破格效果 */
  width: auto;
  object-fit: contain;
  /* 如果你的Logo图本身没有白边，可能需要加阴影让它和黑线区分开，或者你的Logo本身自带描边 */
  filter: drop-shadow(1px 1px 0px #fff); 
}

/* 右侧信息 */
.info-wrapper {
  display: flex;
  align-items: center;
  font-size: 14px;
}

.info-icon {
  color: #00dcd4; /* 亮青色，模仿截图中的颜色 */
  font-size: 16px;
  margin-right: 6px;
  font-weight: bold;
}

.info-label {
  color: #555;
  margin-right: 4px;
  font-weight: 500;
  font-size: 12px;
}

.info-value {
  font-size: 14px;
  font-weight: 700; /* 加粗 */
  color: #0f172a; /* 深蓝黑 */
  font-family: Arial, Helvetica, sans-serif; /* 数字字体 */
}
</style>